import { api } from '../../../services/api'

export type LinkGoogleCalendarOptions = {
  unified_event?: boolean
}

export async function linkGoogleCalendar(
  auth0_id: string,
  options?: LinkGoogleCalendarOptions
): Promise<boolean> {
  const response = await api.post(
    `/api/me/identities/${auth0_id}/google_calendar${options?.unified_event ? '?unified_event=true' : ''}`
  )
  return response.status >= 200 && response.status < 300
}
